export default ({ store }) => {
  store.dispatch('last-order/initialize')
}
